import ProjectTypes from '../../constants/ProjectTypes';
import withRequiredAuth from '../../HOC/withRequiredAuth';
import withRequiredProduct from '../../HOC/withRequiredProduct';
import CoachFinder from './CoachFinder';

export default withRequiredProduct(
  withRequiredAuth(CoachFinder),
  ProjectTypes.COACH,
);
